import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { CartProvider } from '@/context/CartContext';
import { SmoothScroll } from '@/components/SmoothScroll';
import { Marquee } from '@/components/motion/Marquee';
import { Header } from '@/components/Header';
import { Hero } from '@/components/Hero';
import { SoapsSection } from '@/components/SoapsSection';
import { ChocolatesSection } from '@/components/ChocolatesSection';
import { StorySection } from '@/components/StorySection';
import { ContactSection } from '@/components/ContactSection';
import { Footer } from '@/components/Footer';
import { CartDrawer } from '@/components/CartDrawer';

const Landing = () => (
  <CartProvider>
    <SmoothScroll />
    <div className="App font-body text-[var(--cw-text)]">
      <Header />
      <main>
        <Hero />
        <SoapsSection />
        <Marquee items={['SOAP', 'CHOCOLATE', 'HAND POURED', 'NAGPUR · INDIA', 'SLOW MADE', 'SINCE 2026']} />
        <ChocolatesSection />
        <StorySection />
        <Marquee
          items={['SMALL BATCH', 'PLANT BASED', 'SINGLE ORIGIN CACAO', 'FREE SHIPPING · ₹500+', 'MADE BY HAND']}
          duration={70}
          bg="#FEF7CD"
          fg="#0F1B2A"
          accent="#99C1F1"
        />
        <ContactSection />
      </main>
      <Footer />
      <CartDrawer />
      <Toaster position="bottom-right" richColors />
    </div>
  </CartProvider>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
